import { Col, Row, Table } from "antd";
import { COLUMN_TYPE_RECOMMENDATION } from "../../Constants";
import "./QueueTable.css";
import QueueTableColumn from "./QueueTableColumn";
import React from "react";

const QueueTable = ({
  data,
  isLoading,
  onClickDetail,
  onClickEmergency,
  passedQueues,
  passedThreshold,
}) => {
  // queue_id -> queues_passed_count, dari passed_queues di getAllActiveQueue
  const passedProgressById = (passedQueues ?? []).reduce(
    (acc, item) => ({ ...acc, [item?.queue_id]: item?.queues_passed_count }),
    {},
  );

  return (
    <Row>
      <Col span={24}>
        <div className="queue-table-wrapper">
          <Table
            loading={isLoading}
            dataSource={data ?? []}
            columns={QueueTableColumn({
              type: COLUMN_TYPE_RECOMMENDATION.DEFAULT,
              onClickDetail,
              onClickEmergency,
              passedProgressById,
              passedThreshold,
            })}
            pagination={{
              pageSize: 5,
              total: data?.length,
            }}
            scroll={{ x: "max-content", y: 650 }}
          />
        </div>
      </Col>
    </Row>
  );
};

export default QueueTable;
